"use strict";

import * as BlogGrid from "components/BlogGrid";
import * as Selects from "components/Selects";
document.addEventListener("DOMContentLoaded", function () {
  BlogGrid.init();
  Selects.init();
});
